import { FC } from 'react';
import { Icon } from '@frontend/icons';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { Text, Truncated } from '@frontend/design-system';
import { useAppointmentInfo } from '../../../../../hooks';
import { useSendFormsStore } from '../../../../../providers';
import { contextPreviewContainerStyle, textContainerStyle } from './context-preview.styles';

export const ContextPreview: FC = () => {
  const { appointmentAt } = useAppointmentInfo();
  const { formOrPacketToSend, appointmentInfo } = useSendFormsStore(['formOrPacketToSend', 'appointmentInfo']);
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.min });
  return (
    <div css={contextPreviewContainerStyle}>
      <Icon name='forms' size={isMobile ? 24 : 32} />
      <div css={textContainerStyle}>
        <Truncated as={Text} weight='bold'>
          {formOrPacketToSend?.name ?? ''}
        </Truncated>
        <Text color='light' size='medium'>
          {!!appointmentInfo && `${appointmentAt}, ${appointmentInfo?.practitioner}, ${appointmentInfo?.pmsType}`}
        </Text>
      </div>
    </div>
  );
};
